'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Frittatas = (_dec = (0, _reactRedux.connect)(function (state) {
  return { user: state.auth.user };
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Frittatas, _Component);

  function Frittatas() {
    (0, _classCallCheck3.default)(this, Frittatas);
    return (0, _possibleConstructorReturn3.default)(this, (Frittatas.__proto__ || (0, _getPrototypeOf2.default)(Frittatas)).apply(this, arguments));
  }

  (0, _createClass3.default)(Frittatas, [{
    key: 'render',
    value: function render() {
      var styles = require('./Recipes.scss');
      var frittataImg = require('./Assets/frittatas.png');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.recipePanel },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            _react2.default.createElement(
              'h3',
              null,
              'Magnificent Make-Ahead Mini Frittatas'
            )
          ),
          _react2.default.createElement(
            ReactBootstrap.Row,
            null,
            _react2.default.createElement(
              ReactBootstrap.Col,
              { md: 12 },
              _react2.default.createElement(
                'p',
                null,
                'Makes 24 mini-muffins or 16 muffins.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'These mini-frittatas make fantastic snacks or can be paired with a source of grains (e.g. wholegrain bread) and vegies (e.g. salad) for a delicious and nutritious meal. Packed with eggs, dairy and vegetables, each provides a good source of protein, vitamins and minerals for growing bodies, with about half a serve of vegies in each mini-frittata. Use whatever vegetables you have available - these are often a great way to use up whatever is left in the fridge!'
              )
            ),
            _react2.default.createElement(
              ReactBootstrap.Col,
              { md: 8 },
              _react2.default.createElement(
                'p',
                null,
                'Ingredients:'
              ),
              _react2.default.createElement(
                'ul',
                null,
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'span',
                    null,
                    '1 sweet potato, grated [makes ~2 cups]'
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'span',
                    null,
                    '1 zucchini, grated [makes ~1 cup]'
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'span',
                    null,
                    '1 medium carrot, gradted [makes ~1 cup]'
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'span',
                    null,
                    '1 cup frozen peas and corn'
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'span',
                    null,
                    'Small handful of parsley, chopped'
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'span',
                    null,
                    '12 eggs, whisked'
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'span',
                    null,
                    '1/2 cup of milk'
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'span',
                    null,
                    '3/4 cup ricotta cheese, low fat'
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'span',
                    null,
                    '1 cup tasty cheese, grated'
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'span',
                    null,
                    '1/2 cup self-raising flour'
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'span',
                    null,
                    '1 tablespoon baking powder'
                  )
                )
              )
            ),
            _react2.default.createElement(
              ReactBootstrap.Col,
              { md: 3 },
              _react2.default.createElement(ReactBootstrap.Image, { src: frittataImg, responsive: true })
            ),
            _react2.default.createElement(ReactBootstrap.Col, { md: 1 }),
            _react2.default.createElement(
              ReactBootstrap.Col,
              { md: 12 },
              _react2.default.createElement(
                'p',
                null,
                'Instructions:'
              ),
              _react2.default.createElement(
                'ol',
                null,
                _react2.default.createElement(
                  'li',
                  null,
                  'Preheat oven to 180 degrees Celsius. Prepare a muffin tray with paper liners or baking tray with muffin cups.'
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  'Mix all vegetables and parsley together in a large bowl.'
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  'Pour eggs and milk over vegetable mix and stir to coat.'
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  'Add cheese, flour and baking powder and mix until well combined.'
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  'Pour frittata mixture into pre-prepared muffin tins or paper cups. Bake for 30 minutes or until golden and fluffy, and a skewer inserted comes out clean.'
                )
              ),
              _react2.default.createElement(
                'p',
                null,
                'Mini-frittatas can be frozen for up to 3 months and thawed in a fridge or reheated in an oven.'
              )
            )
          )
        )
      );
    }
  }]);
  return Frittatas;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object
}, _temp)) || _class);
exports.default = Frittatas;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Recipes/Frittatas.js
// module id = 1230
// module chunks = 0